var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFill = function SvgFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m1.893 6.553 4.195-4.196a.5.5 0 0 1 .707 0l4.415 4.414-.502.04a1.5 1.5 0 0 0-.942.435l-3.59 3.59a.5.5 0 0 1-.707 0L1.893 7.26a.5.5 0 0 1 0-.707ZM12.335 10.258a1.038 1.038 0 1 1-2.077 0c0-.108.042-.284.148-.515.101-.223.244-.46.401-.678a4 4 0 0 1 .49-.567l.037.035c.133.126.294.313.452.532.157.218.3.455.4.678.106.231.149.407.149.515Zm-.91-1.859-.008.005zm-.249.005-.009-.005z"
  })));
};
export default SvgFill;